import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { Message } from '../Message';
import { WizardContent } from './WizardContent/WizardContent';
import { getCurrentLegCrewType } from '../../selectors/screen';
import { CrewTypes } from '../../service/constants';

export const FlightWizardPage = memo(() => {
    const currentLeg = useSelector((state) => get(state, 'screen.currentLeg'));
    const crewType = useSelector(getCurrentLegCrewType);
    const { t: translate } = useTranslation();

    return currentLeg && crewType === CrewTypes.PCT_CABINSTAFF ? (
        <WizardContent />
    ) : (
        <Message text={translate('messages.noAvailableInfoForLeg')} />
    );
});

FlightWizardPage.displayName = 'FlightWizardPage';
